function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { components } from 'react-select';
import { Content, Wrapper, Icon, Hidden, Description, SubLabel } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var CurrencyIconValueContainer = function CurrencyIconValueContainer(_ref) {
  var children = _ref.children,
      option = _ref.option,
      subLabel = _ref.subLabel;
  var text = option.getValue()[0] ? option.getValue()[0].label ? option.getValue()[0].label : option.getValue()[0].name ? option.getValue()[0].name : '' : '';
  var subtext = option.getValue()[0] && option.getValue()[0].showSubLabel && option.getValue()[0].subLabel ? option.getValue()[0].subLabel : '';
  var icon = option.getValue()[0] && option.getValue()[0].icon;
  var getStyles = option.getStyles;
  var style = getStyles ? getStyles('valueContainer', option) : {};

  if (!option.hasValue) {
    return ___EmotionJSX(components.ValueContainer, option, children);
  }

  return ___EmotionJSX(components.ValueContainer, option, ___EmotionJSX(Wrapper, style, ___EmotionJSX(Content, null, icon && ___EmotionJSX(Icon, null, icon), text, ___EmotionJSX(SubLabel, null, subtext)), subLabel && ___EmotionJSX(Description, null, subLabel)), ___EmotionJSX(Hidden, null, children));
};
export var ValueContainer = function ValueContainer(_ref2) {
  var children = _ref2.children,
      option = _objectWithoutProperties(_ref2, ["children"]);

  return ___EmotionJSX(CurrencyIconValueContainer, {
    option: option
  }, children);
};